export default {
      id: "gridEditButton-usage",
      viewBox: "0 0 34 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#gridEditButton",
      toString: function () {
        return this.url;
      }
    }